import {z} from '@hono/zod-openapi';

export const importHondaRecallResponseSchema = z
  .object({
    messageId: z.string().openapi({example: 'a1b2c3d4-...'}),
  })
  .openapi('ImportHondaRecallResponse');

export type ImportHondaRecallResponse = z.infer<typeof importHondaRecallResponseSchema>;
